import { connect } from 'react-redux';
import { getCurrentUser } from '../../../../publicSession/selectors';
import { getThreadState } from '../../../../CommentThread/selectors';
import { getCommentableTypeForDeviationType } from '../../../redux/helpers';
var mapStateToProps = function (state, ownProps) {
    var deviation = ownProps.deviation;
    var deviationId = deviation.deviationId, typeId = deviation.typeId;
    var commentableTypeId = getCommentableTypeForDeviationType(typeId);
    var threadState = getThreadState(state, commentableTypeId, deviationId);
    var _a = threadState.items, items = _a === void 0 ? [] : _a;
    return {
        currentUser: getCurrentUser(state),
        initialCommentCount: items.length || 0,
        commentableTypeId: commentableTypeId,
    };
};
export default connect(mapStateToProps);
//# sourceMappingURL=ExpandableComments.container.js.map